MoyaComponents.register('site.popup', [
	'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css',
	'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js',
	'https://cdn.jsdelivr.net/npm/js-cookie@3.0.1/dist/js.cookie.min.js',
], (el) => {
	if (!el) {
		return;
	}
	const box = el.querySelector('.box');
	if (!box) {
		return;
	}
	const boxName = box.getAttribute('id');
	if (!boxName) {
		return;
	}
	const cookieName = 'popup_' + boxName;
	if (getCookie(cookieName) === undefined) {
		setTimeout( () => {
			const body = document.querySelector("body");
			body.classList.add('popup');
			const fancybox = new Fancybox([
				{
					src: box,
					type: "html",
				},
			]);

			fancybox.on('destroy', () => {
				body.classList.remove('popup');
				setCookie(cookieName, 1, 365);
			})
		}, 3000)
	}

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + '; path=/';
	}

	function getCookie(name) {
		let value = "; " + document.cookie;
		let parts = value.split("; " + name + "=");

		if (parts.length === 2) {
			return parts.pop().split(";").shift();
		}
	}
});